import { routeNames as baseRouteNames } from '@/assets/js/routeMenus';

export const routeNames = {
  ...baseRouteNames,
  configurationRoutes: [
    'periodList',
    'periodCreate',
    'periodEdit',
    'gradeList',
    'gradeCreate',
    'gradeEdit',
    'holidayList',
    'holidayCreate',
    'holidayEdit',
    'holidayDetail',
    'appFormList',
    'appFormCreate',
    'appFormItems',
    'appFormDetail',
    'appFormEdit',
    'appFormEditItems',
    'timetableTemplateList',
    'timetableTemplateCreate',
    'timetableTemplateDetail',
    'timetableTemplateEdit',
    'shiftSetting',
    'shiftPatternList',
    'shiftPatternCreate',
    'shiftPatternEdit',
    'shiftPatternDetail',
    'teacherTypeList',
    'teacherTypeCreate',
    'teacherTypeEdit',
    'teacherTypeDetail',
    'leaveTypeList',
    'leaveTypeCreate',
    'leaveTypeEdit',
    'leaveTypeDetail',
    'leaveBalanceList',
    'leaveBalanceEdit',
    'positionList',
    'positionCreate',
    'positionEdit',
    'positionDetail',
    'paymentMethodList',
    'paymentMethodCreate',
    'paymentMethodDetail',
    'paymentMethodEdit',
    'paymentAttributeList',
    'paymentAttributeCreate',
    'paymentAttributeEdit',
    'paymentAttributeDetail',
    'gradeFeeList',
    'gradeFeeCreate',
    'gradeFeeEdit',
    'gradeFeeImport',
    'gradeFeeDetail',
    'itemList',
    'itemCreate',
    'itemDetail',
    'itemEdit',
    'itemImport',
    'transactionCategoryList',
    'transactionCategoryCreate',
    'transactionCategoryEdit',
    'transactionCategoryDetail',
    'discountTypeList',
    'discountTypeCreate',
    'discountTypeDetail',
    'discountTypeEdit',
  ],
  academicUsersRoutes: [
    'campusGradeList',
    'campusGradeCreate',
    'campusGradeEdit',
    'campusGradeImport',
    'classList',
    'classCreate',
    'classEdit',
    'classDetail',
    'classImport',
    'subjectList',
    'subjectCreate',
    'subjectEdit',
    'subjectDetail',
    'subjectImport',
    'timetableList',
    'timetableCreate',
    'timetableDetail',
    'timetableEdit',
    'timetableImport',
    'scoreSettingList',
    'scoreSettingDetail',
    'scoreSettingEdit',
    'scoreSettingImport',
    'employeeList',
    'employeeCreate',
    'employeeEdit',
    'employeeDetail',
    'studentList',
    'studentEdit',
    'studentPass',
    'studentFail',
    'studentRestore',
    'studentCreate',
    'studentProfile',
    'parentList',
    'parentCreate',
    'parentEdit',
    'parentDetail',
    'applicantList',
    'applicantDetail',
    'referralManagementList',
  ],
  operationsRoutes: [
    'attendanceStudentList',
    'attendanceStudentDetail',
    'attendanceStudentEdit',
    'attendanceStudentCreate',
    'monthlyAttendance',
    'attendanceRateList',
    'leaveList',
    'leaveCreate',
    'leaveEdit',
    'leaveDetail',
    'attendanceTeacherList',
    'attendanceTeacherDetail',
    'attendanceTeacherEdit',
    'attendanceTeacherCreate',
    'teacherMonthlyAttendance',
    'teacherLeaveList',
    'teacherLeaveCreate',
    'teacherLeaveEdit',
    'teacherLeaveDetail',
    'ShiftAssign',
    'subjectTeacher',
    'subjectTeacherList',
    'subjectTeacherCreate',
    'subjectTeacherEdit',
    'subjectTeacherDetail',
    'subjectTeacherImport',
    'courseList',
    'courseCreate',
    'courseEdit',
    'courseDetail',
    'courseImport',
    'assignmentList',
    'assignmentCreate',
    'assignmentEdit',
    'assignmentDetail',
    'examList',
    'examCreate',
    'examDetail',
    'examEdit',
    'examImport',
    'gradingList',
    'gradingCreate',
    'gradingDetail',
    'gradingEdit',
    'gradingImport',
    'earlyYearList',
    'earlyYearEdit',
    'earlyYearDetail',
    'ClassScoreSummary',
    'reportCardGradingList',
    'reportCardGradingDetail',
    'reportCardGradingImport',
    'reportCardGradingEdit',
    'noticeList',
    'noticeCreate',
    'noticeDetail',
    'noticeEdit',
    'ChatMessageHistory',
    'chatRequestList',
  ],
  financesRoutes: [
    'paymentRequestList',
    'paymentRequestDetail',
    'paymentList',
    'paymentCreate',
    'paymentDetail',
    'paymentEdit',
    'paymentCheckout',
    'studentStatementList',
    'studentStatementDetail',
    'tuitionPaymentDetail',
    'tuitionPaymentEdit',
    'enrollmentCreate',
    'enrollmentPaymentCreate',
    'enrollmentInvoiceCreate',
    'salaryList',
    'salaryCreate',
    'salaryEdit',
    'salaryDetail',
    'SalaryChangesHistoryList',
    'skillList',
    'skillCreate',
    'skillEdit',
    'paymentAttributeDetailList',
    'paymentAttributeDetailCreate',
    'paymentAttributeDetailEdit',
    'payslipList',
    'payslipDetail',
    'transactionList',
    'transactionCreate',
    'transactionBatchCreate',
    'transactionDetail',
    'transactionEdit',
    'paymentMethodBalanceList',
    'refundConfirmation',
    'refundHistoryList',
    'refundHistoryDetail',
  ],
  campusServicesRoutes: [
    'driverList',
    'driverCreate',
    'driverEdit',
    'driverDetail',
    'ferryCreate',
    'ferryList',
    'ferryEdit',
    'ferryDetail',
    'routeList',
    'routeCreate',
    'routeEdit',
    'routeDetail',
    'ferryPickupList',
    'ferryPickupDetail',
    'ferryPickupEdit',
    'dailyFerryList',
    'dailyFerryCreate',
    'dailyFerryEdit',
    'dailyFerryDetail',
    'dailyFerryCopyForm',
    'ferryZoneList',
    'bookList',
    'bookCreate',
    'bookDetail',
    'bookEdit',
    'libraryMemberList',
    'libraryMemberCreate',
    'libraryMemberDetail',
    'libraryMemberEdit',
    'checkoutList',
    'checkoutCreate',
    'checkoutDetail',
    'checkoutEdit',
    'damageLossesList',
    'damageLossesCreate',
    'damageLossesDetail',
    'damageLossesEdit',
    'categoryItems',
  ],
  reportRoutes: [
    'transactionReport',
    'incomeExpenseReport',
    'PassPercentage',
    'TuitionFeePaymentReport',
    'dailyCashflow',
    'monthlyCashflow',
    'yearlyCashflow',
    'financialSummaryReport',
  ],
};
